"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// eslint-disable-next-line
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const pattern_library_components_form_radio_1 = require("@saatva-bits/pattern-library.components.form-radio");
require("./form-radio-group.module.scss");
const CustomRadio = ({ children, className, isSelected, parentChildren, ...childProps }) => {
    const classes = (0, classnames_1.default)(parentChildren.props.className, className);
    return react_1.default.cloneElement(parentChildren, {
        children,
        className: classes,
        isSelected,
        ...childProps,
    });
};
const FormRadioGroup = ({ className, radioClassName, dataSrc, name, showAriaLabel = true, initialSelection, onSelectionUpdate = () => { }, ...props }) => {
    const [selectedValue, setSelectedValue] = (0, react_1.useState)(initialSelection);
    const handleInputChange = (e) => {
        const { value } = e.target;
        setSelectedValue(value);
        onSelectionUpdate(value);
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: className, ...props, children: dataSrc.map((data, index) => {
            const { label, value, ariaLabel, subContent, subContentClassName, childProps, } = data;
            return ((0, jsx_runtime_1.jsx)(pattern_library_components_form_radio_1.FormRadio, { id: `${name}_${data.value}`, formRadioClassName: radioClassName, subContentClassName: subContentClassName, name: name, value: value, label: label, showAriaLabel: showAriaLabel, ariaLabel: ariaLabel, subContent: subContent, selectedValue: selectedValue, handleInputChange: handleInputChange, children: props.children && ((0, jsx_runtime_1.jsx)(CustomRadio, { parentChildren: props.children, isSelected: value === selectedValue, ...childProps, children: label })) }, index));
        }) }));
};
FormRadioGroup.propTypes = {
    /** Applies a custom class to the FormRadioGroup component. */
    className: prop_types_1.default.string,
    /** Applies a custom class to the default button on FormRadio component when no children passed, and build the input and label classnanes as well. */
    radioClassName: prop_types_1.default.string,
    /** Array of values to be showed as FormRadio buttons. */
    dataSrc: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        label: prop_types_1.default.string,
        value: prop_types_1.default.string,
        ariaLabel: prop_types_1.default.string,
        subContent: prop_types_1.default.string,
        subContentClassName: prop_types_1.default.string,
        childProps: prop_types_1.default.string,
    })),
    /** Shows aria-label attribute on the FormRadio buttons. */
    showAriaLabel: prop_types_1.default.bool,
    /** Input name attribute for the FormRadio buttons. */
    name: prop_types_1.default.string.isRequired,
    /** Initial selected value of the FormRadioGroup. */
    initialSelection: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    /** A method used to handle changes on the FormRadiogROUP value. */
    onSelectionUpdate: prop_types_1.default.func,
    children: prop_types_1.default.node
};
exports.default = FormRadioGroup;
//# sourceMappingURL=form-radio-group.js.map